import { Route, Routes } from 'react-router-dom';
import GuestMarketplaceShell from '../pages/market-place/GuestMarketplaceShell';
import Marketplace from '../pages/market-place/MarketPlace';
import MarketPlacePreview from '../pages/market-place/marketPlacePreview';
import GuestMarketplaceCart from '../pages/market-place/GuestMarketplaceCart';
import BreederProfile from '../pages/profile/BreederProfile';

const PublicMarketplaceRoutes = () => {
  return (
    <Routes>
      <Route element={<GuestMarketplaceShell />}>
        <Route index element={<Marketplace guestMode />} />
        <Route path="cart" element={<GuestMarketplaceCart />} />
        <Route path="profile/:accountId" element={<BreederProfile />} />
        <Route path=":marketPlaceSpecimenId" element={<MarketPlacePreview guestMode />} />
      </Route>
    </Routes>
  );
};

export default PublicMarketplaceRoutes;
